//文字コードはutf-8

/* IR動画一覧 — YouTube サムネイル・タイトル自動取得
========================================================*
 * data-modal-src からYouTube動画IDを抽出し、
 * サムネイルとタイトルを自動設定する。
 *
 * ■ 自動取得（デフォルト）
 *   <img> の src が空 → YouTubeサムネイルを自動設定
 *   <h2> のテキストが空 → oEmbed APIでタイトルを自動取得
 *
 * ■ 手動オーバーライド
 *   <img src="手動パス"> → そのまま使用
 *   <h2>手動タイトル</h2> → そのまま使用
 *
========================================================*/

export function initIrMovie() {
    var cards = document.querySelectorAll('.jsIrMovieCard');
    if (!cards.length) return;

    cards.forEach(function (card) {
        var trigger = card.querySelector('.jsModalOpen');
        if (!trigger) return;

        var videoId = extractVideoId(trigger.getAttribute('data-modal-src'));
        if (!videoId) return;

        var img = card.querySelector('.movieFigure img');
        var titleEl = card.querySelector('.titleText');
        var headingEl = card.querySelector('.irMovieList__card__heading');

        // サムネイル: src が空またはプレースホルダーなら自動設定
        if (img && !img.getAttribute('src')) {
            img.src = 'https://img.youtube.com/vi/' + videoId + '/mqdefault.jpg';
        }

        // タイトル: テキストが空なら oEmbed から自動取得
        if (titleEl && !titleEl.textContent.trim()) {
            fetchVideoTitle(videoId, function (title) {
                titleEl.textContent = title;
                // SEO用の見出し要素も更新
                if (headingEl) {
                    headingEl.textContent = title;
                }
                // aria-label も更新
                trigger.setAttribute('aria-label', '動画を再生: ' + title);
            });
        }
    });
}

/**
 * YouTube embed URL または watch URL から動画IDを抽出
 */
function extractVideoId(url) {
    if (!url) return null;
    var match = url.match(/(?:embed\/|watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
}

/**
 * YouTube oEmbed API でタイトルを取得
 */
function fetchVideoTitle(videoId, callback) {
    var oembedUrl = 'https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=' + videoId + '&format=json';
    fetch(oembedUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
            if (data && data.title) {
                callback(data.title);
            }
        })
        .catch(function () {
            // 取得失敗時は何もしない（空のまま or 手動値を維持）
        });
}
